module.exports = __webpack_public_path__ + "static/Josh_2-ec70ab13e34220f5f1e22bde06e0cfab.jpg";